// assets
import { CORE_PERMISSIONS } from '@a1/shared';
import IconClipboardText from '@tabler/icons-react/dist/esm/icons/IconClipboardText';
import IconUserCircle from '@tabler/icons-react/dist/esm/icons/IconUserCircle';
import IconCalendarEvent from '@tabler/icons-react/dist/esm/icons/IconCalendarEvent';
import IconBook2 from '@tabler/icons-react/dist/esm/icons/IconBook2';
import IconLayersSubtract from '@tabler/icons-react/dist/esm/icons/IconLayersSubtract';
import IconLayoutDashboard from '@tabler/icons-react/dist/esm/icons/IconLayoutDashboard';

// ==============================|| MANAGER PAGES MENU ITEMS ||============================== //

const dashboardPages = {
  id: 'dashboardPages',
  title: '',
  type: 'group',
  children: [
    {
      id: 'bookingStats',
      title: 'Booking Dashboard',
      type: 'item',
      url: '/dashboard-booking-stats',
      icon: IconLayoutDashboard,
      breadcrumbs: false,
      minimumPermissions: []
    },
    {
      id: 'surveyStats',
      title: 'Survey Dashboard',
      type: 'item',
      url: '/dashboard-survey-stats',
      icon: IconLayoutDashboard,
      breadcrumbs: false,
      minimumPermissions: []
    }
  ]
};

const otherManagerPages = {
  id: 'managerPages',
  title: '',
  caption: '',
  type: 'group',
  children: [
    {
      id: 'respondents',
      entityId: 'respondents',
      title: 'Assigned Respondents',
      type: 'item',
      url: '/respondents',
      icon: IconUserCircle,
      breadcrumbs: false,
      minimumPermissions: []
    },
    {
      id: 'surveys',
      entityId: 'surveys',
      title: 'Surveys',
      type: 'item',
      url: '/surveys',
      icon: IconClipboardText,
      breadcrumbs: false,
      minimumPermissions: []
    },
    {
      id: 'booking-pages',
      title: 'Bookings Pages',
      type: 'item',
      url: '/manage-booking-pages',
      icon: IconLayersSubtract,
      breadcrumbs: false,
      minimumPermissions: []
    },
    {
      id: 'bookings',
      title: 'Bookings',
      type: 'item',
      url: '/manage-bookings',
      icon: IconBook2,
      breadcrumbs: false,
      minimumPermissions: []
    },
    {
      id: 'booking-calendar',
      title: 'Booking Calendar',
      type: 'item',
      url: '/manage-booking-calendar',
      icon: IconCalendarEvent,
      breadcrumbs: false,
      minimumPermissions: [CORE_PERMISSIONS.BOOKING_CALENDAR_READ]
    }
  ]
};

const managerPages = [dashboardPages, otherManagerPages];

export default managerPages;
